<template>
  <div class="create-user">
    <UserForm mode="create" />
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  components: {
    UserForm: () => import(/* webpackChunkName: "UserForm" */ '@/views/User/UserForm')
  }
}
</script>
